import './firebase.js';

import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.scss';
import App from './App';

import posthog from 'posthog-js';

posthog.init(import.meta.env.VITE_POSTHOG_API_KEY!, {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  ui_host: import.meta.env.VITE_POSTHOG_UI_HOST,
});

declare global {
  interface Window {
    posthog: typeof posthog;
  }
}

window.posthog = posthog;

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
